/**
 * In-page loading state.
 *
 * NOT the `.loader-bg` bar from _Layout.cshtml: that element is torn out of the
 * DOM by pcoded.js on first load (`document.querySelector('.loader-bg').remove()`),
 * so rendering it from React means React and pcoded.js both claim the same node —
 * React then throws "removeChild: The node to be removed is not a child of this
 * node" the moment the loading state ends. The page-load bar is a static element
 * in index.html; this is the spinner the pages themselves used while fetching.
 */
export function Preloader(): JSX.Element {
  return (
    <div className="row g-4 mb-5 mt-5">
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  )
}
